import MonthlyDonationHero from "../assets/Videos/MonthlyDonationHero.mp4";
import SmallVendorHero from "../assets/Videos/Small_Vendor.mp4";

export const Videos = {
  monthlyDonationHero: MonthlyDonationHero,
  smallVendorHero: SmallVendorHero,
};


